<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <reporte-stock-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import ReporteStockShowData from "./ReporteStockShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "ReporteStockShow",
        components: {CrudShow, ReporteStockShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.reporteStock.showing',
            }
        },
    }
</script>

